import EmployeePicklistMetadata from "./picklist/impl/EmployeePicklistMetadata";
import ProtocolPicklistMetadata from "./picklist/impl/ProtocolPicklistMetadata";
import EndpointPicklistMetadata from "./picklist/impl/EndpointPicklistMetadata";
import EventTypePicklistMetadata from "./picklist/impl/EventTypePicklistMetadata";
import SubscriptionStatusPicklistMetadata from "./picklist/impl/SubscriptionStatusPicklistMetadata";
import ActiveInactiveStatusPicklistMetadata from "./picklist/impl/ActiveInactiveStatusPicklistMetadata";

const picklistMetadataClasses: Map<string, object> = new Map();

picklistMetadataClasses.set("EmployeePicklistMetadata", EmployeePicklistMetadata);
picklistMetadataClasses.set("ProtocolPicklistMetadata", ProtocolPicklistMetadata);
picklistMetadataClasses.set("EndpointPicklistMetadata", EndpointPicklistMetadata);
picklistMetadataClasses.set("EventTypePicklistMetadata", EventTypePicklistMetadata);
picklistMetadataClasses.set("SubscriptionStatusPicklistMetadata", SubscriptionStatusPicklistMetadata);
picklistMetadataClasses.set("ActiveInactiveStatusPicklistMetadata", ActiveInactiveStatusPicklistMetadata);

export default function PicklistMetadataClassFactory(name: string): object | undefined{
    return picklistMetadataClasses.get(name + "PicklistMetadata");
}